export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5555.c79c38fd.jpg";